<template>
	<div
		class="experience-block"
		:class="{
			'experience-block--filled': data.basketData,
			'experience-block--disabled': isDisabled
		}"
	>
		<div class="experience-block__header">
			<component class="experience-block__header-icon" :is="`icon-builder-${data.option}`" />

			<div class="experience-block__header-copy">
				<p class="experience-block__header-choose">
					{{
						!!data.basketData
							? $t('page.shop.experience_builder.select')
							: $t('page.shop.experience_builder.choose')
					}}
				</p>

				<p class="experience-block__header-label">
					{{
						label ||
						$t(`page.shop.experience_builder.${data.option}.label`, {
							event: this.shopConfig.festivalData.title
						})
					}}
				</p>
			</div>

			<Arrow-down v-if="!data.basketData && !isDisabled" class="experience-block__header-arrow" />

			<nuxt-link
				v-if="!data.basketData && !isDisabled"
				class="experience-block__header-link"
				:to="{ path: optionRoute, query: $route.query }"
			/>
		</div>

		<component
			v-if="data.basketData"
			class="experience-block__content-block"
			:is="contentComponent"
			:products="data.basketData"
			:route="getSlug"
			:buttonLabel="$t(`page.shop.experience_builder.${data.option}.update`)"
		/>
	</div>
</template>

<script>
import ExperienceContentMembership from './ExperienceContentMembership';
import ExperienceContentTickets from './ExperienceContentTickets';
import ExperienceContentTravel from './ExperienceContentTravel';
import ExperienceContentTravelAddon from './ExperienceContentTravelAddon';
import ExperienceContentMerchandise from './ExperienceContentMerchandise';
import ExperienceContentTransportation from './ExperienceContentTransportation';
import ExperienceContentCompareTransportation from './ExperienceContentCompareTransportation';
import ExperienceContentExtra from './ExperienceContentExtra';
import ExperienceContentPackages from './ExperienceContentPackages.vue';

export default {
	name: 'ExperienceBlock',

	components: {
		ExperienceContentMembership,
		ExperienceContentTickets,
		ExperienceContentTravel,
		ExperienceContentTravelAddon,
		ExperienceContentMerchandise,
		ExperienceContentTransportation,
		ExperienceContentCompareTransportation,
		ExperienceContentExtra,
		ExperienceContentPackages
	},

	props: {
		data: Object,
		label: String,
		isDisabled: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		shopConfig() {
			return this.$store.getters['shopconfig/getData'];
		},

		hasCompareTransportStep() {
			return this.$store.getters['shopconfig/getData'];
		},

		getSlug() {
			let slug = this.data.option;

			if (slug === 'ticket') slug = 'tickets';

			return slug;
		},

		optionRoute() {
			let slug = this.data.option;

			if (slug === 'ticket') slug = 'tickets';
			return `${this.$route.params.slug}/${slug}`;
		},

		contentComponent() {
			return (
				this.data.basketData &&
				{
					membership: 'ExperienceContentMembership',
					ticket: 'ExperienceContentTickets',
					travel: 'ExperienceContentTravel',
					traveladdon: 'ExperienceContentTravelAddon',
					merchandise: 'ExperienceContentMerchandise',
					transportation:
						this.data.option == 'comparetransport'
							? 'ExperienceContentCompareTransportation'
							: 'ExperienceContentTransportation',
					extras: 'ExperienceContentExtra',
					comparetransport: 'ExperienceContentCompareTransportation',
					packages: 'ExperienceContentPackages'
				}[this.data.option]
			);
		}
	}
};
</script>

<style lang="scss">
$component: 'experience-block';

.#{$component} {
	border: 1px solid #5e5e66;
	border-radius: 2px;

	&--disabled {
		.#{$component} {
			&__header-icon,
			&__header-copy {
				opacity: 0.4;
			}
		}
	}

	&--filled {
		overflow: hidden;

		border-radius: 16px;

		.#{$component} {
			&__header {
				border-radius: 16px 16px 0 0;
				background-image: linear-gradient(
					180deg,
					var(--content-background-dark) 0%,
					var(--content-background-light-2) 100%
				);
			}
		}
	}

	&__header {
		position: relative;

		box-shadow: inset 0px 0px 0px 2px $color-black;
		background-image: linear-gradient(
			180deg,
			var(--content-background-dark) 0%,
			var(--content-background-light-2) 100%
		);
	}

	&__header {
		display: flex;
		align-items: center;

		height: 70px;

		line-height: 1.2;

		padding: 0 $global-spacing;
	}

	&__header-icon {
		width: 30px;
		margin-right: $global-spacing;

		path {
			fill: var(--primary-body-color);
		}
	}

	&__header-copy {
		flex: auto;
	}

	&__header-choose {
		font-size: 14px;
	}

	&__header-label {
		font-size: 20px;
		font-family: $font-medium;
	}

	&__header-arrow {
		transform: rotate(-90deg);

		path {
			fill: var(--primary-body-color);
		}
	}

	&__header-link {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	&__white-header {
		// used in tickets, transportation and merchandise content

		padding: calc($global-spacing / 2) $global-spacing;
		margin-bottom: $global-spacing;

		font-size: 16px;
		font-family: $font-medium;
		color: $color-black;

		background-color: $color-white;

		border: 2px solid $color-black;

		&--first {
			border-top: none;
		}
	}

	&__content-block {
		position: relative;

		background-image: linear-gradient(
			180deg,
			var(--content-background-dark) 0%,
			var(--content-background-light-2) 100%
		);

		// box-shadow: inset 0px 0px 0px 2px $color-black;

		border-radius: 0 0 16px 16px;
		box-shadow: inset 0px 0px 0px 2px $color-black;
	}
}
</style>
